import { z } from 'zod';
import { looseEmailSchema } from '@/shared/lib/validation/email';
import { optionalVatIdSchema } from '@/shared/lib/validation/vat-id/vat-id.schema';
import { MAX_FILE_SIZE, MAX_FILES } from '@/shared/config/report-form';


const optionalString = z.preprocess(
    (v) => (v === '' || v == null ? undefined : v),
    z.string().optional(),
);


export const reportApiSchema = z.object({
    cargo_category: optionalString,
    company_name  : z.string().min(1),
    description   : z.string().min(1),
    email         : looseEmailSchema,
    files         : z
        .array(z.instanceof(File))
        .max(MAX_FILES)
        .refine((files) => files.every((file) => file.size <= MAX_FILE_SIZE)),
    incident_date : z.string().min(1),   // приходит как ISO-строка (с формы уже toISOString())
    route_from    : optionalString,
    route_to      : optionalString,
    vat_number    : optionalVatIdSchema,
    your_email    : z.string().min(1).pipe(z.email()),
});


export const reportFormSchema = z.object({
    cargo_category: z.string().optional(),
    company_name  : z.string().min(1, 'Company name is required'),
    description   : z.string().min(1, 'Description is required'),
    email         : looseEmailSchema,
    files         : z
        .array(z.instanceof(File))
        .max(MAX_FILES, `Maximum ${ MAX_FILES } files allowed`)
        .refine(
            (files) => files.every((file) => file.size <= MAX_FILE_SIZE),
            `Each file must be less than ${ MAX_FILE_SIZE / 1024 / 1024 }MB`,
        ),
    incident_date : z.date({ error: 'Incident date is required' }).transform((d) => d.toISOString()),
    route_from    : z.string().optional(),
    route_to      : z.string().optional(),
    vat_number    : optionalVatIdSchema,
    your_email    : z.string().min(1, 'Email is required').pipe(z.email('Invalid email')),
});


export type ReportFormInput  = z.input<typeof reportFormSchema>;   // incidentDate?: Date
export type ReportFormOutput = z.output<typeof reportFormSchema>;  // incidentDate?: string
